import { useFetcher } from "@remix-run/react";
import { EntryCollection } from "contentful";
import chunk from "lodash/chunk";
import qs from "qs";
import { useEffectOnce } from "react-use";
import {
  IInsightFields,
  SpecificLocaleFields,
} from "~/@types/generated/contentful";
import { fallbackLanguage } from "~/i18n-config";
import { contentfulInsightGetters } from "~/utils";
import InsightCardWithImage from "./InsiteCardWithImage";

type InsightCardGroupFetcherProps = {
  linksTo?: string;
  excludeSlug: string[];
  skip: number;
  topicSlug?: string[];
  tagSlugs?: string[];
  expertSlugs?: string[];
};

export function InsightCardGroupFetcher({
  linksTo,
  excludeSlug,
  topicSlug,
  tagSlugs,
  expertSlugs,
  skip,
}: InsightCardGroupFetcherProps) {
  const insightsFetcher =
    useFetcher<EntryCollection<SpecificLocaleFields<IInsightFields>>>();

  useEffectOnce(() => {
    insightsFetcher.submit(
      new URLSearchParams(
        qs.stringify({
          linksTo,
          excludeSlug,
          topicSlug,
          tagSlugs,
          expertSlugs,
          skip,
          locale: fallbackLanguage,
        }),
      ),
      {
        action: "/api/insights",
        method: "get",
        preventScrollReset: true,
      },
    );
  });

  if (!insightsFetcher.data) return null;

  return (
    <>
      {chunk(insightsFetcher.data.items, 3).map((chunk) => (
        <InsightCardWithImage
          key={chunk[0].sys.id}
          insights={chunk.map(contentfulInsightGetters)}
        />
      ))}
    </>
  );
}
